import { render, staticRenderFns } from "./VueHub.vue?vue&type=template&id=0a4f6c80&"
import script from "./VueHub.vue?vue&type=script&lang=js&"
export * from "./VueHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports